import React from 'react';
import Label from "components/general/Label"
import { Container } from 'react-bootstrap';
import { useAbsoluteRoot } from 'helpers/urlRoot';


export default function NotAvailable({ label = "LabelNoDataAvailableResultPage" }) {
  const { urlRoot } = useAbsoluteRoot();
  return (
    <div className='container py-5'>
      <em className="d-flex  fw-bold  justify-content-center">
        <Label data={label} />
      </em>
    </div>
  )
}
